/* eslint-disable import/no-duplicates */
/* eslint-disable react/sort-comp */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { Grid, IconButton, TableBody } from '@material-ui/core'
import Application from 'react-notifications-component'
import ReactNotification from 'react-notifications-component'
import AppsIcon from '@material-ui/icons/Apps'
import MapTwoTone from '@material-ui/icons/MapTwoTone'
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive'
import moment from 'moment'
import MenuIcon from '@material-ui/icons/Menu'
import { styles } from './Orders.styles'
import {
  Button,
  DateRangePicker,
  EmptyView,
  BottomNavigationIcon,
  MapOrders,
  OrderItem,
  OrderModal,
  Paper,
  Table,
  TableFooter,
  Title, TermsAcceptanceModal
} from '../../components'
import 'react-notifications-component/dist/theme.css'
import * as actions from '../../actions/index'
import {
  ALL_ORDERS,
  ICON_ORDER_TYPES,
  mainColor,
  ORDER_FUTURE,
  ORDER_HISTORY,
  ORDER_IN_PROGRESS,
  ORDER_PHASE_CONTACTING,
  ORDER_PHASE_PREPARING,
  ORDER_TYPE_COLLECT,
  ORDER_TYPE_DELIVERY,
  ORDER_TYPE_SEAT,
  SUITABLE_ORDER_TYPES,
  UNIT,
  PULL_INDEPENDENT_DRIVERS_INTERVALL_ORDERS
} from '../../constants'
import { getEstimationTime, getOrdersWithStatus, NoDriverToast } from '../../utils/orderUtils'
import { isObjectNotEmpty } from '../../utils/tools'
import {
  clearIntervalSong,
  clearIntervalTime,
  getBottomNavigationComponentSize,
  getBottomNavigationData,
  getDrivers,
  getOrdersShopId,
  handleClick,
  handleClose,
  handleCompositionOrders,
  handleLoadAudio,
  onChangeData,
  onChangeLayout,
  onSelectDate,
  updateTime,
  getOrdersSound,
  getFirstOrderPhase, getOrdersPhaseContactingInReverseFlow, handleAcceptDeliveryCgu, closeAcceptConditionsModal, closeDeliverooInfo,
  clearReopenModalInterval, displayClosedShopModal, showReopenModal, setupReopenModalInterval, checkDeliveryProximity, clearDeliveryAlert
} from './Orders.services'
import { ORDERS_TABLE_HEAD } from '../../constants/table'
import { ReactComponent as ImportedSVG } from '../../assets/pictures/orders.svg'
import { EMPTY_DESIGN_ORDERS_TEXT, EMPTY_DESIGN_ORDERS_TITLE } from '../../constants/dishopInfo'
import { getInitialDateRange } from '../../utils/suitableDate'
import { isFreelanceEnabled } from '../../utils/delivery'
import { printTicket } from '../../components/OrderModal/OrderModal.service';
import { clearDriversInterval, fetchAllDrivers } from '../../apis/firebase';
const INITIAL_STATE = {
  isLoading: true,
  orderTypeSelected: 0,
  selectedType: ALL_ORDERS,
  selectedToType: [ORDER_IN_PROGRESS, ORDER_FUTURE, ORDER_HISTORY],
  driversAvailability: {},
  order: {},
  isGrid: true,
  currentDate: moment(),
  viewedOrders: [],
  orders: {},
  dateRange: getInitialDateRange(),
  deliverooInfo: false,
  showDeliverooInfo: false,
  showAcceptConditionsModal: false,
  lastClosedModalShownAt: null,
  reopenModalInterval: null,
  isFirstLoad: true,
  currentOrders: {}
};
class Orders extends Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
  }
  async componentDidMount() {
    const { showModal, shopId, isAllShops } = this.props;
    handleCompositionOrders(this, this.state, this.props);
    updateTime(this);
    showModal({
      color: 'primary',
      title: 'Cliquez pour commencer à traiter vos commandes',
      btnTxt: 'Commencer',
      onClick: () => { handleLoadAudio(this); this.setState({ showAcceptConditionsModal: true, hasStarted: true }); displayClosedShopModal(this); checkDeliveryProximity(this.props.externalDrivers, this); },
      handleClose: () => { handleLoadAudio(this); this.setState({ showAcceptConditionsModal: true, hasStarted: true }); displayClosedShopModal(this); checkDeliveryProximity(this.props.externalDrivers, this); },
      size: 'xs'
    });
    if (!isAllShops) {

      fetchAllDrivers(PULL_INDEPENDENT_DRIVERS_INTERVALL_ORDERS, shopId);
    }
    getDrivers(this.props, this);



  }



  renderAcceptConditionsModal = () => {
    const { showModal } = this.props;
    const { showAcceptConditionsModal } = this.state;

    if (!showAcceptConditionsModal) return null;

    const handleCheckboxChange = (checked) => {
      this.setState({
        deliverooInfo: checked
      });
    };

    const checkboxContent = (
      <div style={{ fontSize: 12 }}>
        <p>En cochant cette case, je reconnais avoir lu et accepté les  <a
          href='#'
          target="blank"
          onClick={(event) => {
            event.preventDefault();
            this.setState({
              showDeliverooInfo: !this.state.showDeliverooInfo
            });
          }}
        >
          Conditions Générales d'Utilisation du service Deliveroo Express
        </a> via l'application en marque blanche de Dishop dans leur intégralité.
        </p>

      </div>
    );

    const modalData = {
      color: 'success',
      title: 'Utilisation du Service Deliveroo Express',
      btnTxt: 'Confirmer',
      header: true,
      message: <p>Dans le cadre de l'utilisation du service Deliveroo Express, Veuillez lire et accepter les Conditions Générales d'Utilisation</p>,
      handleClose: closeAcceptConditionsModal(this),
      onClick: () => handleAcceptDeliveryCgu(this, showModal),
      checkedText: false,
      checkboxes: [{
        text: checkboxContent,
        onChange: handleCheckboxChange,
      }],
    };

    return showModal(modalData);
  };


  componentWillUnmount() {
    clearIntervalSong();
    clearIntervalSong(true);
    clearDeliveryAlert();
    clearIntervalTime();
    clearDriversInterval();
    clearReopenModalInterval(this);
  }

  async componentWillUpdate(nextProps, nextState) {
    const { orderTypeSelected, selectedToType } = nextState;
    const { orderTypeSelected: oldOrderTypeSelected, dateRange } = this.state;
    const {
      orders: oldOrders,
      shopId: oldShopId,
      finishedOrders: oldFinishedOrders,
      isAllShops: oldIsAllShops,
      independentDrivers: oldIndependentDrivers,
      drivers: oldDrivers,
      externalDrivers: oldExternalDrivers
    } = this.props;

    const { orders, shopId, finishedOrders, isAllShops, independentDrivers, drivers, deliveroo, externalDrivers } = nextProps;
    if (deliveroo?.enabled && !deliveroo?.acceptedTerms) {
      this.renderAcceptConditionsModal()
    }
    if (this.props.closed !== nextProps.closed) {
      if (nextProps.closed) {
        this.setState({ isFirstLoad: true }, () => {
          showReopenModal(this);
          setupReopenModalInterval(this);
        });
      } else {
        clearReopenModalInterval(this);
      }
    }

    const currentOrdersPhasePreparing = this.getOrdersByPhase(oldOrders, shopId, isAllShops, ORDER_PHASE_PREPARING);
    const nextOrdersPhasePreparing = this.getOrdersByPhase(orders, shopId, isAllShops, ORDER_PHASE_PREPARING);
    if (this.shouldFetchFinishedOrders(oldShopId, shopId, oldIsAllShops, isAllShops, selectedToType, orderTypeSelected)) {
      await this.props.getFinishedOrders(shopId, dateRange, true, isAllShops);
    }

    else if (
      this.shouldUpdateOrders(
        oldOrderTypeSelected,
        orderTypeSelected,
        oldShopId,
        shopId,
        oldOrders,
        orders,
        oldFinishedOrders,
        finishedOrders,
        oldIsAllShops,
        isAllShops,
        selectedToType,
      )
    ) {
      await this.handleOrdersUpdate(
        oldOrders,
        orders,
        shopId,
        oldShopId,
        isAllShops,
        oldIsAllShops,
        nextState,
        nextProps,
        currentOrdersPhasePreparing,
        nextOrdersPhasePreparing,
        selectedToType,
        orderTypeSelected
      );
    }

    if (this.shouldUpdateDrivers(oldDrivers, drivers, oldIndependentDrivers, independentDrivers)) {
      getDrivers(nextProps, this);
    }

    if (this.shouldUpdatePreparingOrders(nextOrdersPhasePreparing, currentOrdersPhasePreparing)) {
      this.handlePreparingOrdersUpdate(nextOrdersPhasePreparing, currentOrdersPhasePreparing);
    }
    if (this.shouldFetchAllDrivers(isAllShops, oldShopId, shopId)) {
      fetchAllDrivers(PULL_INDEPENDENT_DRIVERS_INTERVALL_ORDERS, shopId);
    }

    if (this.state.hasStarted && this.shouldCheckDeliveryProximity(
      oldOrders,
      orders,
      oldExternalDrivers,
      externalDrivers,
      oldShopId,
      shopId,
      oldIsAllShops,
      isAllShops
    )) {
      await checkDeliveryProximity(externalDrivers, this);
    }


  }

  getOrdersByPhase(orders, shopId, isAllShops, phase) {
    return getOrdersWithStatus(getOrdersShopId(orders, shopId, isAllShops), phase);
  }

  shouldFetchFinishedOrders(oldShopId, shopId, oldIsAllShops, isAllShops, selectedToType, orderTypeSelected) {
    return (
      (!_.isEqual(oldShopId, shopId) || (_.isEqual(oldShopId, shopId) && !_.isEqual(oldIsAllShops, isAllShops))) &&
      selectedToType[orderTypeSelected] === ORDER_HISTORY
    );
  }
  shouldUpdateOrders(
    oldOrderTypeSelected,
    orderTypeSelected,
    oldShopId,
    shopId,
    oldOrders,
    orders,
    oldFinishedOrders,
    finishedOrders,
    oldIsAllShops,
    isAllShops,
    selectedToType,
  ) {
    return (
      orderTypeSelected !== oldOrderTypeSelected ||
      !_.isEqual(oldShopId, shopId) ||
      !_.isEqual(oldOrders, orders) ||
      (!_.isEqual(oldFinishedOrders, finishedOrders) && selectedToType[orderTypeSelected] === ORDER_HISTORY) ||
      (_.isEqual(oldShopId, shopId) && !_.isEqual(oldIsAllShops, isAllShops))
    );
  }
  shouldCheckDeliveryProximity(
    oldOrders,
    orders,
    oldExternalDrivers,
    externalDrivers,
    oldShopId,
    shopId,
    oldIsAllShops,
    isAllShops
  ) {
    const shopChanged =
      oldShopId !== shopId || (oldShopId === shopId && oldIsAllShops !== isAllShops);

    const ordersChanged = !_.isEqual(oldOrders, orders);
    const driversChanged = !_.isEqual(oldExternalDrivers, externalDrivers);

    return shopChanged || ordersChanged || driversChanged;
  }

  async handleOrdersUpdate(
    oldOrders,
    orders,
    shopId,
    oldShopId,
    isAllShops,
    oldIsAllShops,
    nextState,
    nextProps,
    currentOrdersPhasePreparing,
    nextOrdersPhasePreparing,
    selectedToType,
    orderTypeSelected
  ) {
    const currentOrdersPhaseContacting = this.getOrdersByPhase(oldOrders, shopId, isAllShops, ORDER_PHASE_CONTACTING);
    const nextOrdersPhaseContacting = this.getOrdersByPhase(orders, shopId, isAllShops, ORDER_PHASE_CONTACTING);
    const currentOrderPhaseSearchingDrivers = getFirstOrderPhase(currentOrdersPhaseContacting);
    const nextOrderPhaseSearchingDrivers = getFirstOrderPhase(nextOrdersPhaseContacting);

    if (
      (this.shouldPlayOrderSound(nextOrdersPhaseContacting, currentOrdersPhaseContacting, oldShopId, shopId, oldIsAllShops, isAllShops) || this.shouldPlayDriverSound(nextOrderPhaseSearchingDrivers, currentOrderPhaseSearchingDrivers, oldShopId, shopId, oldIsAllShops, isAllShops))
    ) {
      clearIntervalSong(true);
      clearIntervalSong();
      getOrdersSound(nextOrdersPhaseContacting);
    }
    if (getOrdersPhaseContactingInReverseFlow(nextOrdersPhaseContacting).length === 0) {
      clearIntervalSong();
    }


    if (_.keys(nextOrderPhaseSearchingDrivers).length === 0) {
      clearIntervalSong(true);
    }

    if (nextOrdersPhasePreparing.length > currentOrdersPhasePreparing.length) {
      const newOrders = this.getNewOrders(nextOrdersPhasePreparing, currentOrdersPhasePreparing, currentOrdersPhaseContacting);
      this.printNewOrders(newOrders);
    }

    clearIntervalTime();
    if (selectedToType[orderTypeSelected] !== ORDER_HISTORY) {
      updateTime(this);
    }
    getDrivers(nextProps, this);
    handleCompositionOrders(this, nextState, nextProps);
  }
  shouldPlayOrderSound(
    nextOrdersPhaseContacting,
    currentOrdersPhaseContacting,
    oldShopId,
    shopId,
    oldIsAllShops,
    isAllShops
  ) {
    const hasNewOrders = nextOrdersPhaseContacting.some(
      order => !currentOrdersPhaseContacting.find(o => o.chargeId === order.chargeId)
    );

    const hasChanges = nextOrdersPhaseContacting.some(order => {
      const current = currentOrdersPhaseContacting.find(o => o.chargeId === order.chargeId);
      return current && (
        current.orderType !== order.orderType ||
        current.pickupStatus !== order.pickupStatus
      );
    });
    const hasShopChanged = (!_.isEqual(oldShopId, shopId) ||
      (_.isEqual(oldShopId, shopId) && !_.isEqual(oldIsAllShops, isAllShops))) &&
      nextOrdersPhaseContacting.length > 0;
    return (hasNewOrders || hasChanges || hasShopChanged);
  }

  getNewOrders(nextOrdersPhasePreparing, currentOrdersPhasePreparing, currentOrdersPhaseContacting) {
    return _.filter(nextOrdersPhasePreparing, order => {
      const isInCurrentPreparing = _.find(currentOrdersPhasePreparing, { chargeId: order.chargeId });
      const isInCurrentContacting = _.find(currentOrdersPhaseContacting, { chargeId: order.chargeId });
      return !isInCurrentPreparing && isInCurrentContacting;
    });
  }
  printNewOrders(newOrders) {
    newOrders.forEach(order => {
      const { datePreparationEnded } = getEstimationTime(order);
      printTicket(this, { ...order, datePreparationEnded }, true);
    });
  }

  shouldUpdateDrivers(oldDrivers, drivers, oldIndependentDrivers, independentDrivers) {
    return !_.isEqual(oldDrivers, drivers) || !_.isEqual(oldIndependentDrivers, independentDrivers);
  }

  shouldUpdatePreparingOrders(nextOrdersPhasePreparing, currentOrdersPhasePreparing) {
    return !_.isEqual(nextOrdersPhasePreparing, currentOrdersPhasePreparing);
  }

  handlePreparingOrdersUpdate(nextOrdersPhasePreparing, currentOrdersPhasePreparing) {
    _.map(nextOrdersPhasePreparing, order => {
      const currentOrder = _.find(currentOrdersPhasePreparing, { chargeId: order.chargeId, orderType: ORDER_TYPE_DELIVERY });
      NoDriverToast(currentOrder, order);
    });
  }

  shouldFetchAllDrivers(isAllShops, oldShopId, shopId) {
    return !isAllShops && !_.isEqual(oldShopId, shopId);
  }
  shouldPlayDriverSound(nextOrderPhaseSearchingDrivers, currentOrderPhaseSearchingDrivers, oldShopId, shopId, oldIsAllShops, isAllShops) {
    return (
      _.filter(nextOrderPhaseSearchingDrivers, order => !_.find(currentOrderPhaseSearchingDrivers, { chargeId: order.chargeId })).length > 0 ||
      ((!_.isEqual(oldShopId, shopId) || (_.isEqual(oldShopId, shopId) && !_.isEqual(oldIsAllShops, isAllShops))) &&
        nextOrderPhaseSearchingDrivers.length > 0))
  }

  getviewedOrders = () => {
    const { classes } = this.props;
    const { selectedType, orders } = this.state;
    return _.map(orders, (e, index) => {
      return (
        <IconButton
          className={`${index === ALL_ORDERS ? 'mr-sm-2' : 'mx-sm-2'}  ${classes.arroundIcon} my-0`}
          style={{
            color: selectedType === index ? mainColor.colorWhite : mainColor.colorBlack,
            backgroundColor:
              selectedType === index ? mainColor.secondaryColor : mainColor.colorWhite,
            borderColor: selectedType === index && mainColor.secondaryColor
          }}
          onClick={() => {
            this.setState({ selectedType: index, viewedOrders: e })
            this.props.updatePage(0)
          }}
        >
          <div className='w-100 d-flex justify-content-between align-items-center'>
            {ICON_ORDER_TYPES[index] || ''}
            <b
              className={index === ALL_ORDERS ? 'd-flex my-1 m-sm-1' : 'd-none d-md-flex mx-md-1'}
              style={{
                fontSize: UNIT * 0.75,
                color: selectedType === index ? mainColor.colorWhite : mainColor.colorBlack
              }}
            >
              {{ allOrders: 'Tout', ...SUITABLE_ORDER_TYPES }[index]}
            </b>
            <div className='d-none d-sm-flex'>
              <b
                className={classes.boldText}
                style={{
                  color: selectedType === index ? mainColor.colorWhite : mainColor.colorBlack,
                  backgroundColor: selectedType === index ? `#73bdaa` : mainColor.backGroundColor
                }}
              >
                {_.size(e)}
              </b>
            </div>
          </div>
        </IconButton>
      );
    });
  };

  createTableRow = (currRecords, currentDate, orderItem) => {
    const { selectedType } = this.state;
    return (
      <TableBody>
        {_.map(currRecords, (e, key) => {
          return (
            <OrderItem
              key={key.toString()}
              item={e}
              filtredType={selectedType}
              currentDate={currentDate}
              orderItem={orderItem}
              onClick={() => handleClick({ order: e }, this)}
            />
          );
        })}
      </TableBody>
    );
  };

  renderTable = (currRecords, currentDate, orderItem) => {
    const { classes, isAllShops } = this.props;
    const { selectedType, orderTypeSelected, selectedToType } = this.state;
    const FILTER_ORDERS_TABLE_HEAD = isAllShops
      ? ORDERS_TABLE_HEAD
      : _.filter(ORDERS_TABLE_HEAD, elt => elt.id !== 'Magasin');

    return (
      <div className='col-12 p-0'>
        <Paper scrollOption='auto'>
          <Table
            headCells={
              selectedType === ORDER_TYPE_SEAT || selectedType === ORDER_TYPE_COLLECT
                ? FILTER_ORDERS_TABLE_HEAD.filter(i => i.id !== 'userNameDep')
                : FILTER_ORDERS_TABLE_HEAD
            }
            classes={classes}
            bodyRows={currRecords}
            createTableRow={rows => this.createTableRow(rows, currentDate, orderItem)}
            order={selectedToType[orderTypeSelected] === ORDER_HISTORY ? 'desc' : 'asc'}
            orderBy='date'
          />
        </Paper>
      </div>
    );
  };

  render() {
    const { classes, showHelpModal, page, isAllShops, shopId } = this.props;
    const { numPage, rowsPerPage } = page;
    const {
      orderTypeSelected,
      driversAvailability,
      selectedToType,
      order = {},
      modalOpen,
      currentDate,
      isGrid,
      viewedOrders = {},
      dateRange,
      isLoading
    } = this.state;
    const { nbDriversAvailable = 0, nbDriversFreelance = 0 } = driversAvailability;
    const oneCloche = false;
    const iconList = getBottomNavigationData(selectedToType);
    const classNameBottomNavigationSize = getBottomNavigationComponentSize(iconList.length);
    const orderItem = viewedOrders.find(elt => elt.chargeId === order.chargeId);
    return (
      <div className='px-4 pb-4'>
        <div className='d-flex justify-content-between align-items-center'>
          <Title title='Commandes' onClick={() => showHelpModal('commandes')} />
        </div>
        <div>
          <div className='row'>
            <div className={`col-12 ${classNameBottomNavigationSize} mb-3`}>
              <Paper className={classes.paperStyle}>
                {selectedToType.map((e, i) => {
                  const display =
                    !oneCloche && this.state[e] && orderTypeSelected !== i ? true : 'none';

                  return (
                    <NotificationsActiveIcon
                      className={classes.notificationStyle}
                      key={Math.random()
                        .toString(36)
                        .substring(2, 15)}
                      style={{ display, left: `${(100 * i + 76) / selectedToType.length}%` }}
                    />
                  );
                })}
                <BottomNavigationIcon
                  value={this.state.orderTypeSelected}
                  onChange={(event, newValue) => {
                    onChangeData(event, newValue, rowsPerPage, this);
                  }}
                  selectedEntity={this.state.orderTypeSelected}
                  collection={iconList}
                />
              </Paper>
            </div>
            {isFreelanceEnabled(shopId) &&
              selectedToType[orderTypeSelected] !== ORDER_HISTORY &&
              !isAllShops && (
                <div className='col-12 col-sm-7 col-md-5 col-lg-4 col-xl-3 mb-3'>
                  <Paper className={classes.driverSection}>
                    <p className={classes.textStyle}>
                      {nbDriversAvailable}{' '}
                      {nbDriversAvailable > 1
                        ? 'livreurs salariés disponibles'
                        : 'livreur salarié disponible'}
                    </p>
                    <p className={classes.textStyle} style={{ marginTop: -UNIT * 0.3125 }}>
                      {nbDriversFreelance}{' '}
                      {nbDriversFreelance > 1
                        ? `livreurs indépendants disponibles`
                        : 'livreur indépendant disponible'}
                    </p>
                  </Paper>
                </div>
              )}
            {selectedToType[orderTypeSelected] === ORDER_HISTORY && (
              <div className='mb-3 col d-block d-sm-flex justify-content-sm-end align-items-end'>
                <DateRangePicker
                  className=''
                  dateRange={dateRange}
                  onSelectDate={dateRange => {
                    onSelectDate(this, dateRange);
                  }}
                  disabled={isLoading}
                />
              </div>
            )}
            {selectedToType[orderTypeSelected] !== ORDER_HISTORY && !isAllShops && (
              <div className='mb-3 col d-flex justify-content-end align-items-end'>
                <Button
                  className='btn-xs-block'
                  outlined
                  color='secondary'
                  onClick={() => {
                    const { showModal } = this.props;
                    const modalData = {
                      color: 'secondary',
                      title: 'Vos livreurs',
                      header: true,
                      children: (
                        <MapOrders
                          isLoading={this.state.isLoading}
                          orders={_.filter(
                            viewedOrders,
                            order =>
                              order.orderType === '' || order.orderType === ORDER_TYPE_DELIVERY
                          )}
                        />
                      ),
                      width: '700px',
                      // handleClose: handleClose(this),
                      center: true,
                      modalBodyClass: 'justify-content-center d-flex pb-0',
                      btnTxt: 'Retour'
                    };
                    showModal(modalData);
                  }}
                >
                  <MapTwoTone style={{ marginRight: UNIT * 0.3125 }} />
                  Suivre vos livreurs
                </Button>
              </div>
            )}
          </div>
          <div className='mb-3 w-100 d-flex justify-content-between align-items-center'>
            <div className=' justify-content-between align-items-center d-sm-flex '>
              {!this.state.isLoading && this.getviewedOrders()}
            </div>
            <div>
              {this.state.isLoading || !_.size(viewedOrders) > 0 ? null : (
                <div>
                  <IconButton
                    aria-label='grid'
                    style={{
                      border: isGrid && '2px solid',
                      backgroundColor: isGrid && 'transparent',
                      borderColor: isGrid && mainColor.secondaryColor
                    }}
                    className={`mx-sm-2 ${classes.arroundIcon} my-0`}
                    onClick={() => onChangeLayout(true, this)}
                  >
                    <AppsIcon style={{ color: isGrid && mainColor.secondaryColor }} />
                  </IconButton>
                  <IconButton
                    aria-label='Menu'
                    className={`ml-sm-2 ${classes.arroundIcon} my-0 `}
                    style={{
                      marginRight: 0,
                      padding: UNIT * 0.375,
                      border: !isGrid && '2px solid',
                      backgroundColor: !isGrid && 'transparent',
                      borderColor: !isGrid && mainColor.secondaryColor
                    }}
                    onClick={() => onChangeLayout(false, this)}
                  >
                    <MenuIcon style={{ color: !isGrid && mainColor.secondaryColor }} />
                  </IconButton>
                </div>
              )}
            </div>
          </div>
          {this.state.isLoading || !_.size(viewedOrders) > 0 ? (
            <EmptyView
              className={classes.svg}
              src={ImportedSVG}
              isLoading={this.state.isLoading}
              title={EMPTY_DESIGN_ORDERS_TITLE}
              text={EMPTY_DESIGN_ORDERS_TEXT}
            />
          ) : (
            <div>
              {!isGrid ? (
                this.renderTable(viewedOrders, currentDate, orderItem)
              ) : (
                <Grid container spacing={5}>
                  {_.map(
                    viewedOrders.slice(numPage * rowsPerPage, numPage * rowsPerPage + rowsPerPage),
                    (order, key) => {
                      return (
                        <OrderItem
                          key={key.toString()}
                          isGrid
                          currentDate={currentDate}
                          item={order}
                          orderItem={orderItem}
                          onClick={() => handleClick({ order }, this)}
                        />
                      );
                    }
                  )}
                </Grid>
              )}
              <TableFooter
                lengthOption={viewedOrders.length}
                defaultRowsPerPage={isGrid ? 12 : 10}
                rowsPerPageOptions={isGrid ? [12, 24, 48] : [10, 20, 50]}
              />

              {isObjectNotEmpty(orderItem) && (
                <OrderModal
                  order={orderItem}
                  orderItem={orderItem}
                  isOpen={modalOpen}
                  handleClose={() => handleClose(this)}
                  driversAvailability={driversAvailability}
                />
              )}
            </div>
          )}
        </div>

        <div>
          <ReactNotification />
          <Application />
          {this.state.showDeliverooInfo &&
            <TermsAcceptanceModal
              showDeliverooInfo={this.state.showDeliverooInfo}
              handleClose={() => { closeDeliverooInfo(this) }} />}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ orders, user, firebaseRealTime, page }) => {
  const { finishedOrders = [] } = orders;
  const {
    shop = {},
    generalConfig = {},
    independentDrivers = [],
    drivers = [],
    shops,
    externalDrivers
  } = firebaseRealTime;
  const { configuration = {}, closed } = shop;
  const { webapp = {}, terminal = {}, qrcode = {}, mobileApp = {}, stuart = {}, uberDirect = {} } = generalConfig;
  const { orderTypes = [ORDER_TYPE_DELIVERY, ORDER_TYPE_COLLECT], autoAccept = {}, deliveroo = {} } = configuration;
  const { shopId, dashboardConfig, contactingButtons, address = {}, isAllShops } = user;
  const { location = {} } = address;
  return {
    finishedOrders,
    orders: orders.orders,
    shopId,
    orderTypes,
    dashboardConfig,
    contactingButtons,
    shop,
    page,
    webapp,
    terminal,
    qrcode,
    mobileApp,
    stuart,
    uberDirect,
    location,
    independentDrivers,
    drivers,
    isAllShops,
    shops,
    autoAccept,
    deliveroo, closed,
    externalDrivers: _.map(externalDrivers, (driver, key) => ({ ...driver, driverId: key }))
  };
};

Orders.propTypes = {
  classes: PropTypes.element.isRequired
};

export default connect(mapStateToProps, actions)(withStyles(styles)(Orders));
